import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { INotificationActionResult } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { ITermTranslationsUploadState, getInitialTermTranslationsUploadState, ITermTranslationsUploadError } from "./TermTranslationsUpload.state";

const initialState = getInitialTermTranslationsUploadState();

export const termTranslationsUpload = createSlice({
  name: "termTranslationsUpload",
  initialState: initialState,
  reducers: {
    uploadTranslations: (state: ITermTranslationsUploadState, _action: PayloadAction<File[]>) => {
      return {
        ...state,
        uploadProcessing: true,
        uploadCompleted: false,
        notifications: [],
        error: undefined,
        progress: 1
      };
    },
    uploadTranslationsProcessing: (state: ITermTranslationsUploadState, action: PayloadAction<number>) => {
      return {
        ...state,
        progress: action.payload
      };
    },
    resetUploadingTranslations: () => {
      return initialState;
    },
    uploadTranslationsCompleted: (state: ITermTranslationsUploadState) => {
      return {
        ...state,
        uploadProcessing: false,
        uploadCompleted: true
      };
    },
    uploadTranslationsFailed: (state: ITermTranslationsUploadState, action: PayloadAction<INotificationActionResult<ITermTranslationsUploadError>>) => {
      return {
        ...state,
        progress: 0,
        uploadProcessing: false,
        uploadCompleted: true,
        notifications: action.payload.notification ? [action.payload.notification] : [],
        error: action.payload.data
      };
    },
    uploadTranslationsError: (state: ITermTranslationsUploadState, action: PayloadAction<INotification>) => {
      return { ...state, progress: 0, uploadProcessing: false, notifications: [action.payload] };
    }
  },
  extraReducers: getScreenExtraReducers<ITermTranslationsUploadState>("notifications", initialState)
});
